import {Injectable} from '@angular/core';
import {NavController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {AuthApiService} from '../Api/Auth/auth-api.service';
import {ToastManagerService} from '../Platform/Ionic/toast-manager.service';
import {EventsManagerService} from './events-manager.service';
import {DataManagerService} from './data-manager.service';
import {PusherManagerService} from '../Platform/Capacitor/pusher-manager.service';
import {RoutesEnum} from '../../Shared/Enum/routes.enum';
import {WidgetsManagerService} from './widgets-manager.service';
import {ModulesManagerService} from './modules-manager.service';
import {MultisessionManagerService} from './multisession-manager.service';

@Injectable({
  providedIn: 'root'
})
export class SessionManagerService {

  constructor(
    protected auth: AuthApiService,
    protected navCtrl: NavController,
    protected toastCtrl: ToastManagerService,
    protected pusherCtrl: PusherManagerService,
    protected eventsManager: EventsManagerService,
    protected dataManager: DataManagerService,
    protected widgetsManager: WidgetsManagerService,
    protected modulesManager: ModulesManagerService,
    protected multisessionManager: MultisessionManagerService,
    protected translate: TranslateService,
  ) {
  }


  /**
   * Manejar la sesión inválida
   *
   */
  public handleSessionExpired(force: boolean = false) {

    if (force) {
      this.toastCtrl.showWarningToast(this.translate.instant('SERVER.SESSION_EXPIRED'));
    }

    this.auth.deleteUserSession();
    this.dataManager.destroyData();

    this.widgetsManager.cleanWidgetsData();
    this.modulesManager.cleanModulesData();
    this.multisessionManager.resetMultisessionConfig();

    this.pusherCtrl.disconnectAll();
    this.eventsManager.unsubscribeAll();

    this.navCtrl.navigateRoot(RoutesEnum.onboarding, {animated: !force, animationDirection: 'back'});
  }

}
